import {useSelector, useDispatch} from 'react-redux';

import {IState} from '../../../store/reducers';
import {ApiStatus, IBlock} from '../../../models';
import {updateBlocks} from '../../../store/actions/blockActions';
import {BaseBlock} from '../types';

interface UseUpdateBlocks {
  isUpdating: boolean;
  updateBlocks: (reportBlocks?: any) => void;
}

export function useUpdateBlocks(): UseUpdateBlocks {
  /*
   * trigger bulk update blocks, for all the blocks that are marked as dirty in the redux store
   */
  const updating = useSelector((state: IState) => state.block.updatingStatus);
  const blocks = useSelector((state: IState) => state.block.blocks);
  const dispatch = useDispatch();

  const _updateBlocks = (reportBlocks?: any[]) => {
    /*
     * Update dirty blocks.
     */
    let dirtyBlocks = blocks?.filter((block: IBlock) => block.is_dirty);
    if (!dirtyBlocks?.length) {
      return;
    }
    if (reportBlocks?.length || 0 > 0) {
      /*
       * If reportBlocks are provided, we will update only the blocks that are part of the report.
       */
      const blockIds: any = reportBlocks
        ?.filter((block: Partial<BaseBlock>) => block.block_id !== undefined)
        .map((block: Partial<BaseBlock>) => block.block_id);

      dirtyBlocks = dirtyBlocks.filter((block: IBlock) => blockIds.includes(block.id));
    }

    dispatch(updateBlocks(dirtyBlocks.map((block: IBlock) => ({
      uid: block.uid,
      content_json: JSON.stringify(block.content_json || {}),
    }))));
  };

  return {
    isUpdating: updating === ApiStatus.LOADING,
    updateBlocks: _updateBlocks,
  }
}
